import React from 'react';
import AscOrdersTable from 'pages/MyOrdersPage/AscOrders/Tables/AscOrdersTable';

const AscOrders = () => {
  return <AscOrdersTable />;
};

export default AscOrders;
